import React from 'react'
import { FormControl } from 'react-bootstrap'

const T = (props) => {
  return (
    <div style={{display:'inline-block'}}>
      {props.label && <span className="labelz">{props.label}</span>}
      <FormControl componentClass="textarea" {...props} />
    </div>
  )
}

export default T


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Textarea.js